module.exports = __webpack_public_path__ + "img/icon-table-sort.c077f889.svg";